<button mat-raised-button color="primary" *appRole="['Contratos.GenerarResumen']" (click)="openDialogGenerarResumenMensual()">
  <mat-icon>change_circle</mat-icon>
  Generar Resumenes Mensuales
</button>
